var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#D80000",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.875 16.25C7.53125 16.25 7.23708 16.1277 6.9925 15.8831C6.74792 15.6385 6.62542 15.3442 6.625 15V6.875H6V5.625H9.125V5H12.875V5.625H16V6.875H15.375V15C15.375 15.3438 15.2527 15.6381 15.0081 15.8831C14.7635 16.1281 14.4692 16.2504 14.125 16.25H7.875ZM9.125 13.75H10.375V8.125H9.125V13.75ZM11.625 13.75H12.875V8.125H11.625V13.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.f4c1d335699d9d4ee13436950c4ad2b0.svg";
export { ForwardRef as ReactComponent };